import { fixMath } from "./fixMath";

/**
 * Reverse the fee calculation
 * @param totalBeforeFee - The total before the fee
 * @param ratePerPayment - The rate per payment
 * @param feePerPayment - The fee per payment
 * @returns The fee
 * 
 * For example, if you want to receive $100 after Stripe's 2.9% + $0.30 fee, t
 * his calculation tells you how much to charge the customer so you end up with exactly $100 
 * after Stripe takes their cut.
 */
export const reverseFeeCalculation = (
    totalBeforeFee: number,
    ratePerPayment: number = 2.9,
    feePerPayment: number = 0.30
) => {
    totalBeforeFee = totalBeforeFee || 0;
    ratePerPayment = ratePerPayment || 0;
    feePerPayment = feePerPayment || 0;
    return fixMath.subtract(
        fixMath.divide(
            fixMath.multiply(
                100,
                fixMath.add(totalBeforeFee, feePerPayment)
            ),
            fixMath.subtract(100, ratePerPayment)
        ),
        totalBeforeFee
    );
}

export const inclusiveRate = (gross: number, rate: number) => {
    gross = gross || 0;
    rate = rate || 0;
    return fixMath.subtract(
        gross,
        fixMath.divide(
            gross,
            fixMath.add(1, fixMath.divide(rate, 100))
        )
    );
}

export const exclusiveRate = (total: number, rate: number) => {
    total = total || 0;
    rate = rate || 0;
    return fixMath.multiply(
        total,
        fixMath.divide(rate, 100)
    );
}


// console.log(`inclusiveRate(100, 20) = ${inclusiveRate(100, 20)}`); // 16.66666666666667
// console.log(`exclusiveRate(100, 20) = ${exclusiveRate(100, 20)}`); // 20